import { render, staticRenderFns } from "./fourthIndex.vue?vue&type=template&id=c87e448e&scoped=true&"
import script from "./fourthIndex.vue?vue&type=script&lang=js&"
export * from "./fourthIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87e448e",
  null
  
)

export default component.exports